import { buildRequestParams } from "./../helpers/index.js";
import { performRequest } from "./nuxtApp.js";
export function useGraphqlQuery(...args) {
  const [name, variables, fetchOptions = {}, graphqlCaching = {}] = typeof args[0] === "string" ? [args[0], args[1], args[2]?.fetchOptions, args[2]?.graphqlCaching] : [
    args[0].name,
    args[0].variables,
    args[0].fetchOptions,
    args[0].graphqlCaching
  ];
  return performRequest(
    "query",
    name,
    "get",
    {
      params: buildRequestParams(variables),
      ...fetchOptions
    },
    graphqlCaching
  );
}
